import script from "./SchoolTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./SchoolTableComponent.vue?vue&type=style&index=0&id=6aba9167&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aba9167"]])

export default __exports__